import { HierarchyUtils, SnapRootComponent, SnapUtils, TransformUtils, RelativeConnectorRepositioner, } from "@inter-ikea-core/core";
import { getAdjustableStateComponent, getConnectorsComponent, } from "./componentGetters";
import { MOVEABLE } from "../constants";
export const adjustSize = (entity, guestConnectorKey, host, hostConnector) => {
    const moveablePart = getAdjustableMoveablePart(entity);
    const oldWorldTransform = TransformUtils.worldTransform(moveablePart);
    const guestConnector = getConnectorsComponent(moveablePart).getConnectorByKey(guestConnectorKey);
    if (!guestConnector)
        throw new Error("No guest connector found on entity.");
    moveablePart.addComponent(new SnapRootComponent());
    const { endTransform } = SnapUtils.getSnap(moveablePart, guestConnector, host, hostConnector) || {};
    if (!endTransform)
        throw new Error("No endTransform found on snapActionCandidate.");
    TransformUtils.setWorldTransform(moveablePart, endTransform);
    RelativeConnectorRepositioner.repositionRelativeConnectorsFromBounds(entity);
    return {
        rollbackSize: () => {
            TransformUtils.setWorldTransform(moveablePart, oldWorldTransform);
            RelativeConnectorRepositioner.repositionRelativeConnectorsFromBounds(entity);
        },
    };
};
export const getAdjustableMoveablePart = (entity) => {
    const moveablePart = HierarchyUtils.children(entity).find((child) => {
        var _a;
        const adjustableState = (_a = getAdjustableStateComponent(child, true)) === null || _a === void 0 ? void 0 : _a.state;
        return adjustableState === MOVEABLE;
    });
    if (!moveablePart)
        throw new Error("Entity lacking the necessary characteristics of an adjustable assembly");
    return moveablePart;
};
